import { Alert, Box } from '@ksyos/design-system';
import { HolterDownloadText } from './HolterDownloadText';
import { HolterTimeoutText } from './HolterTimeOutText';

interface IHolterCurrentProps {
    appearance: 'danger' | 'info' | 'success' | 'warning';
    cancelButton?: JSX.Element;
    clearButton?: JSX.Element;
    disableTimer?: number;
    hasDesktopProcessTimedOut?: boolean;
    inModal?: boolean;
    isHalfWidth?: boolean;
    isLoading?: boolean;
    noKsyosHandler?: boolean;
    readButton?: JSX.Element;
    text?: string;
    uploadPercentage?: number;
}

export function HolterCurrent(props: Readonly<IHolterCurrentProps>) {
    const {
        appearance,
        cancelButton,
        isHalfWidth,
        isLoading,
        inModal,
        clearButton,
        hasDesktopProcessTimedOut,
        noKsyosHandler,
        readButton,
        text,
        uploadPercentage,
    } = props;

    return (
        <div className={isHalfWidth ? 'col-sm-12' : 'col-sm-24'}>
            <Alert
                appearance={appearance}
                hasIcon={!isLoading}
                isLoading={isLoading}
                style={inModal ? { marginBottom: '0.5rem', marginTop: 0 } : {}}
            >
                {text ?? ''}
                {uploadPercentage && <Alert.Progress value={uploadPercentage} />}
                {noKsyosHandler && <HolterDownloadText />}
                {hasDesktopProcessTimedOut && !noKsyosHandler && <HolterTimeoutText />}
            </Alert>
            {(cancelButton || clearButton || readButton) && (
                <Box
                    alignItems={['stretch', 'baseline', 'stretch', 'baseline']}
                    display="flex"
                    flexDirection={['column', 'row', 'column', 'row']}
                    justifyContent="flex-end"
                    mb={3}
                    mt={3}
                    sx={{ 'button + button': { ml: [0, 3, 0, 3], mt: 2 } }}
                >
                    {' '}
                    {cancelButton}
                    {clearButton}
                    {readButton}
                </Box>
            )}
        </div>
    );
}
